module.exports = __webpack_public_path__ + "static/media/52775099_2452980754777101_1257872728451448832_o.24e4bfa4.jpg";